import type { RouteLocationNormalized } from 'vue-router'
import type { useAuthStore } from '@/stores/auth'

export async function guardAuthRoute(
  to: Pick<RouteLocationNormalized, 'meta' | 'fullPath'>,
  auth: Pick<ReturnType<typeof useAuthStore>, 'authenticated' | 'verify'>,
) {
  if (to.meta.public) return true
  const verified = auth.authenticated && await auth.verify()
  if (to.meta.guest) return verified ? { name: 'dashboard' } : true
  if (!verified) return { name: 'login', query: { redirect: to.fullPath } }
  return true
}
